import { render, staticRenderFns } from "./ProductSalesStatusSettingPopupIframe.vue?vue&type=template&id=60d5a158&"
import script from "./ProductSalesStatusSettingPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesStatusSettingPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports